import { type ReactNode } from "react";

export function RequireDispatchAccess({ children }: { children: ReactNode }) {
  return <>{children}</>;
}
